import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import routeConfiguration from '../../routing/routeConfiguration';
import { createResourceLocatorString } from '../../util/routes';
import { isScrollingDisabled } from '../../ducks/ui.duck';
// import LayoutWrapperTopbar from '../../components/LayoutWrapperTopbar/LayoutWrapperTopbar'
// import LayoutWrapperMain from '../../components/LayoutWrapperMain/LayoutWrapperMain'
// import LayoutWrapperFooter from '../../components/LayoutWrapperFooter/LayoutWrapperFooter'
import FooterContainer from '../FooterContainer/FooterContainer.js';

// import Footer from '../../components/Footer/Footer'
import {
  // Page,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  // Footer,
} from '../../components/LayoutComposer';
import {Page} from '../../components';
import { LocationSearchForm } from '../../forms/LocationSearchForm/LocationSearchForm';
// import { TopbarContainer } from '../../containers';
import TopbarContainer from '../TopbarContainer/TopbarContainer';

import css from './NoResultFoundPage.module.css';

export class NoResultFoundComponent extends Component {
  constructor(props) {
    super(props);
    // The StaticRouter component used in server side rendering
    // provides the context object. We attach a `notfound` flag to
    // the context to tell the server to change the response status
    // code into a 404.
    this.props.staticContext.notfound = true;
  }

  render() {
    const { history, intl, scrollingDisabled } = this.props;

    const title = intl.formatMessage({
      id: 'NotFoundPage.title',
    });

    const handleSearchSubmit = values => {
      const { search, selectedPlace } = values.location;
      const { origin, bounds } = selectedPlace;
      const searchParams = { address: search, origin, bounds };
      history.push(
        createResourceLocatorString('SearchPage', routeConfiguration(), {}, searchParams)
      );
    };

    return (
      <Page title={`Blog | No posts found`} scrollingDisabled={scrollingDisabled}>
        <LayoutSingleColumn>
          <LayoutWrapperTopbar>
            <TopbarContainer />
          </LayoutWrapperTopbar>
          <LayoutWrapperMain>
            <div className={css.root}>
              <div className={css.content}>
                <div className={css.number}>No posts found.</div>
              </div>
            </div>
          </LayoutWrapperMain>
          <LayoutWrapperFooter>
        <FooterContainer/>

            {/* <Footer /> */}
          </LayoutWrapperFooter>
        </LayoutSingleColumn>
      </Page>
    );
  }
}

NoResultFoundComponent.defaultProps = {
  staticContext: {},
};

const { bool, func, object, shape } = PropTypes;

NoResultFoundComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // context object from StaticRouter, injected by the withRouter wrapper
  staticContext: object,

  // from injectIntl
  intl: intlShape.isRequired,

  // from withRouter
  history: shape({
    push: func.isRequired,
  }).isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const NotResultFoundPage = compose(
  withRouter,
  connect(mapStateToProps),
  injectIntl
)(NoResultFoundComponent);

export default NotResultFoundPage;
